







































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

import { ILocation } from '@/models/location';

import eventBus from '@/utils/eventBus';

import CloseModalIcon from '@/components/icons/CloseModal.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import LocationsAndWebsiteCard from '@/componentsV2/organisms/LocationsAndWebsiteCard/LocationsAndWebsiteCard.vue';

type TriggerPosition = 'header' | 'footer';

@Component({
  components: {
    CloseModalIcon,
    Typography,
    FilledButton,
    LocationsAndWebsiteCard
  }
})
export default class LocationsGroupedByCityModal extends Vue {
  @Prop(String) title!: string;
  @Prop({ default: () => [] }) locations!: Array<ILocation>;
  @Prop({ default: '' }) website?: string;

  observer: IntersectionObserver | null = null;
  triggerVisibility: Record<TriggerPosition, boolean> = {
    header: false,
    footer: false
  };

  created() {
    document.onkeydown = this.handleOnkeydown;
    this.resizeEventHandler();
  }

  mounted() {
    this.handleTriggerObserver();
  }

  beforeDestroy() {
    if (this.observer) this.observer.disconnect();
  }

  @Watch('$route')
  onRouteChange() {
    this.onClose();
  }

  handleTriggerObserver() {
    this.observer = new IntersectionObserver(
      entries => {
        for (const entry of entries) {
          const position = entry.target.getAttribute(
            'data-position'
          ) as TriggerPosition;

          this.triggerVisibility[position] =
            !entry.isIntersecting && !!position;
        }
      },
      {
        root: document.querySelector('.locations-group-modal__body'),
        rootMargin: '24px',
        threshold: 0
      }
    );

    const targets = document.querySelectorAll<HTMLElement>(
      '.locations-group-modal__body-trigger'
    );

    for (const target of targets) {
      this.observer.observe(target);
    }
  }

  onClose() {
    eventBus.$emit('closeModal');
  }

  handleOnkeydown({ key }: KeyboardEvent) {
    if (key === 'Escape') {
      this.onClose();
    }
  }

  resizeEventHandler() {
    const vh = window.innerHeight * 0.01;

    document.documentElement.style.setProperty(
      '--locations-group-modal-vh',
      `${vh}px`
    );
  }
}
